export const DEFAULT_AUTO_CLOSE_DURATION = 4000;
export const DEFAULT_ERROR_AUTO_CLOSE_DURATION = 7000;
